var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ProgressBar'),_c('header',{staticClass:"header"},[_c('Logo')],1),_vm._l((_vm.chapters),function(chapter,index){return _c(chapter.component,{key:index,tag:"component",attrs:{"track":chapter.track}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }